/**
 * useAuth hook — convenience wrapper around AuthContext
 */
import { useContext } from 'react';
import { AuthContext } from './AuthContext';

const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export default useAuth;
